/**
 *  TableWidget script file
**/

import customFormatters from '@/filters/customFormatters'

export default {
  name: 'TableWidget',
  mixins: [customFormatters],
  components: {},
  props: {
    showProgressUsingColumn: {
      type: String,
      required: false
    },
    columns: {
      type: Array,
      default: []
    },
    data: {
      type: Array,
      default: []
    }
  },
  data () {
    return {}
  },
  computed: {
    totalUsignColumn () {
      if (this.data && this.data.length) {
        return this.data.reduce((acum, current) => {
          return acum + current[this.showProgressUsingColumn]
        }, 0)
      }
    }
  },
  methods: {
  }
}
